import _ from "lodash";
/** external */
import React from "react";
import { TextList } from "@toddle-edu/ds-web";
import classNames from "classnames";

/** internal */
import I18nHOC from "UIComponents/I18nHOC";

/** relative */
import classes from "./GenericListView.scss";

// appending key and value to the object
const getListViewFormatStructure = ({
  nodes,
  rootNodeIds,
  shouldEmphasisRootNodes,
  showCode,
}) => {
  const rootParentNode = [
    {
      key: "root",
      children: rootNodeIds,
    },
  ];
  const rootNodeIdsSet = new Set(rootNodeIds);
  const updatedNodes = _.map(nodes, item => {
    const nodeValue =
      showCode && item?.code
        ? `${item.label} (${item.code})`
        : item.label || item.value;
    return {
      ...item,
      key: item.id,
      value: nodeValue,
      fontWeight:
        shouldEmphasisRootNodes && rootNodeIdsSet.has(item.id)
          ? "bold"
          : "normal",
      fontColor: rootNodeIdsSet.has(item.id) ? "primary" : "secondary",
    };
  });
  return _.concat(rootParentNode, updatedNodes);
};

const getListStructureMemoized = _.memoize(getListViewFormatStructure, params =>
  JSON.stringify(params)
);

const GenericListView = props => {
  const { nodes, rootNodeIds, t, type, showCode, label } = props;

  return !_.isEmpty(rootNodeIds) ? (
    <div className={classes.container}>
      <TextList
        data={getListStructureMemoized({ nodes, rootNodeIds, showCode })}
        type={type}
        listMarkers={["disc"]}
        label={label}
      />
    </div>
  ) : (
    <span className={classNames("text-body", classes.emptyText)}>
      {t("common:not_selected")}
    </span>
  );
};

export default I18nHOC({ resource: "common" })(GenericListView);

GenericListView.defaultProps = {
  nodes: [],
  rootNodeIds: [],
  type: "unordered",
  shouldEmphasisRootNodes: true, // determines whether to display root nodes in bold
  showCode: false, // determines whether to display code along with label
};
